import TakeBackBags from './TakeBackBags';

export default TakeBackBags;
